module.exports = __webpack_public_path__ + "static/ROTTENMAP-f8d0bfbce617e010938861c9576cfc85.png";